<div class="form-container">
  <form nz-form nzLayout="vertical" [formGroup]="calendarioForm" (ngSubmit)="onSubmit()">
    
    <!-- Form Actions -->
    <nz-form-item class="flex end">
      <button 
        nz-button 
        nzType="primary" 
        type="submit"
        [disabled]="!isFormValid"
        class="excel-button">
        Aceptar
      </button>
    </nz-form-item>

    <!-- Mes Contable -->
    <nz-form-item>
      <nz-form-label nzFor="mesContable"><div class="bold-title">Mes Contable:</div></nz-form-label>
      <nz-form-control [nzErrorTip]="mesErrorTpl">
        <nz-select
          id="mesContable"
          formControlName="mesContable"
          nzPlaceHolder="Selecciona el mes contable">
          <nz-option
            *ngFor="let mes of meses"
            [nzValue]="mes"
            [nzLabel]="mes">
          </nz-option>
        </nz-select>
        <ng-template #mesErrorTpl let-control>
          <ng-container *ngIf="control.hasError('required')">
            El mes contable es obligatorio
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>

    <!-- Periodo Inicio -->
    <nz-form-item>
      <nz-form-label nzFor="periodoInicio"><div class="bold-title">Período Inicio:</div></nz-form-label>
      <nz-form-control [nzErrorTip]="periodoInicioErrorTpl">
        <nz-date-picker
          id="periodoInicio"
          formControlName="periodoInicio"
          nzFormat="dd/MM/yyyy"
          nzPlaceHolder="Selecciona fecha de inicio del período"
          [nzAllowClear]="false"
          [nzDisabledDate]="disabledDate"
          >

        </nz-date-picker>
        <ng-template #periodoInicioErrorTpl let-control>
          <ng-container *ngIf="control.hasError('required')">
            La fecha de inicio del período es obligatoria
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>

    <!-- Periodo Fin -->
    <nz-form-item>
      <nz-form-label nzFor="periodoFin"><div class="bold-title">Período Fin:</div></nz-form-label>
      <nz-form-control [nzErrorTip]="periodoFinErrorTpl">
        <nz-date-picker
          id="periodoFin"
          formControlName="periodoFin"
          nzFormat="dd/MM/yyyy"
          nzPlaceHolder="Selecciona fecha de fin del período"
          [nzAllowClear]="false"
          [nzDisabledDate]="disabledDate"
          >
        </nz-date-picker>
        <ng-template #periodoFinErrorTpl let-control>
          <ng-container *ngIf="control.hasError('required')">
            La fecha de fin del período es obligatoria
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>

    <!-- Límite Info Colaborador -->
    <nz-form-item>
      <nz-form-label nzFor="limiteInfoColaborador"><div class="bold-title">Límite Info Colaborador:</div></nz-form-label>
      <nz-form-control [nzErrorTip]="limiteColaboradorErrorTpl">
        <nz-date-picker
          id="limiteInfoColaborador"
          formControlName="limiteInfoColaborador"
          nzFormat="dd/MM/yyyy HH:mm"
          nzShowTime
          [nzAllowClear]="false"
          nzPlaceHolder="Selecciona fecha y hora límite para colaborador"
          [nzDisabledDate]="disabledDate"
          >
        </nz-date-picker>
        <ng-template #limiteColaboradorErrorTpl let-control>
          <ng-container *ngIf="control.hasError('required')">
            El límite de información del colaborador es obligatorio
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>

    <!-- Límite Info SAP -->
    <nz-form-item>
      <nz-form-label nzFor="limiteInfoSap"><div class="bold-title">Límite Info SAP:</div></nz-form-label>
      <nz-form-control [nzErrorTip]="limiteSapErrorTpl">
        <nz-date-picker
          id="limiteInfoSap"
          formControlName="limiteInfoSap"
          nzFormat="dd/MM/yyyy HH:mm"
          nzShowTime
          [nzAllowClear]="false"
          nzPlaceHolder="Selecciona fecha y hora límite para SAP"
          [nzDisabledDate]="disabledDate"
          class="red-date-picker"
          >
        </nz-date-picker>
        <ng-template #limiteSapErrorTpl let-control>
          <ng-container *ngIf="control.hasError('required')">
            El límite de información de SAP es obligatorio
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>

      <!-- Nota de actualización de fechas -->
    <div *ngIf="Edicion" class="fecha-actualizada-nota">
      <i nz-icon nzType="info-circle" nzTheme="outline"></i>
      <span>Se han actualizado las Fechas al año actual</span>
    </div>

  </form>
</div>
